<template>
    <b-modal
        id="watch-module-modal"
        v-model="modal"
        :title="module && module.title"
        :ok-title="$t('common.close')"
        ok-only
        size="xl"
        modal-class="apprentice-default-modal"
        @hide="onHide">
        <div
            class="module-details"
            v-if="module">
            <div class="header">
                <b-img :src="module.getBanner()"></b-img>
            </div>
            <div class="module-info">
                <div
                    class="tag muted-text"
                    v-for="tag in tags"
                    v-if="tags.length > 0"
                    :key="tag.id">
                    <i
                        class="fas fa-fw fa-circle"
                        :style="{ color: tag.color }"></i
                    >{{ tag.name }}
                </div>
            </div>
            <design-2021-apprentice-display-html-component
                class="description"
                :html-content="module.description"></design-2021-apprentice-display-html-component>
            <br />
            <div>{{ $t('common.location') }} {{ module.location }}</div>
            <div v-for="user of module.getTeachers()">Docent: {{ user }}</div>

            <div
                class="dates"
                v-if="module.module_dates.length >= 1">
                <div v-if="error">
                    <b-alert
                        show
                        variant="danger"
                        >{{ $t('modules.sign_in_sign_out_not_possible') }}</b-alert
                    >
                </div>
                <design-2021-apprentice-data-table
                    :fields="fields"
                    :items="tableData"
                    nosearch>
                    <template v-slot:cell(when)="data">
                        {{ data.item.day }} {{ data.item.start_time }} - {{ data.item.end_time }}
                    </template>
                    <template v-slot:cell(registrations)="data">
                        <div class="registration">{{ data.item.module_users.length }} / {{ data.item.max }}</div>
                    </template>

                    <template v-slot:cell(motivation)="data">
                        <b-button
                            class="btn-comments-fad btn-show-module-motivation remove-icon-margin"
                            v-if="
                                data.item.findRegister(data.item, $authUser.id) &&
                                data.item.findRegister(data.item, $authUser.id).motivation
                            "
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('modules.view_motivation')"
                            @click="
                                openMotivationEditModal(data.item.findRegister(data.item, $authUser.id), data.item)
                            ">
                        </b-button>
                        <b-button
                            class="btn-comment btn-show-module-motivation remove-icon-margin btn-icon-only"
                            v-else>
                        </b-button>
                    </template>

                    <template v-slot:cell(actions)="data">
                        <div v-if="showRegister(data.item)">
                            <b-button
                                class="btn-sign-out btn-module-sign-out remove-icon-margin"
                                v-b-tooltip.hover
                                v-if="data.item.userHasRegistration($authUser.id)"
                                variant="danger-icon-only"
                                :title="$t('modules.unregister')"
                                @click="unRegisterForModule(data.item)"></b-button>
                            <b-button
                                class="btn-sign-in btn-module-sign-in remove-icon-margin"
                                v-b-tooltip.hover
                                v-if="
                                    !data.item.userHasRegistration($authUser.id) &&
                                    data.item.module_users.length < data.item.max
                                "
                                v-b-modal="'watch-module-motivation-modal-' + data.item.id"
                                variant="primary-icon-only"
                                :title="$t('modules.sign_in')">
                            </b-button>

                            <design-2021-module-show-module-motivation-modal-component
                                :module-in="module"
                                :date-in="data.item"
                                @check-date="checkDate"
                                @update-signed-user="
                                    updateSignedUser
                                "></design-2021-module-show-module-motivation-modal-component>

                            <span
                                v-if="
                                    !data.item.userHasRegistration($authUser.id) &&
                                    data.item.module_users.length >= data.item.max
                                "
                                >Vol</span
                            >
                        </div>
                        <div v-else>
                            <p v-if="signInTill(data.item)">{{ $t('modules.registrations_not_open_yet') }}]</p>
                            <p v-else>
                                {{ $t('modules.registrations_expired') }}
                            </p>
                        </div>
                    </template>
                </design-2021-apprentice-data-table>

                <design-2021-module-show-motivation-edit-modal-component :ref="'edit-module-motivation-modal'">
                </design-2021-module-show-motivation-edit-modal-component>
            </div>
        </div>
    </b-modal>
</template>

<script>
import { ords } from '../../../app';
import moment from 'moment';

export default {
    name: 'design-2021-module-show-module-modal-component',
    props: {},
    data() {
        return {
            subscription: null,
            module: null,
            moduleTitle: '',
            tags: [],
            moduleDates: [],
            selectedDate: 0,
            modal: false,
            fields: [
                {
                    key: 'title',
                    label: this.$t('modules.period'),
                },
                {
                    key: 'when',
                    label: this.$t('modules.when'),
                },
                {
                    key: 'sign_up_from_date',
                    label: this.$t('modules.registration_from'),
                },
                {
                    key: 'sign_up_until_date',
                    label: this.$t('modules.registrations_for'),
                },
                {
                    key: 'duration',
                    label: this.$t('modules.amount_of_hours'),
                },
                {
                    key: 'registrations',
                    label: this.$t('modules.amount_of_registrations'),
                },
                {
                    key: 'motivation',
                    label: this.$t('modules.motivation'),
                },
                {
                    key: 'actions',
                    label: this.$t('common.actions'),
                },
            ],
            error: false,
            selectedModuleDate: null,
        };
    },
    computed: {
        tableData() {
            return this.module.module_dates.map((mdate) => {
                mdate.title = mdate.module_period.period.title;
                mdate.period = mdate.module_period.period;
                mdate.day = mdate.module_period.weekday;
                mdate.start_time = mdate.module_period.time_start.slice(0, 5);
                mdate.end_time = mdate.module_period.time_end.slice(0, 5);
                mdate.sign_up_until_date = this.formatDate(mdate.module_period.period.sign_up_until_date);
                mdate.sign_up_from_date = this.formatDate(mdate.module_period.period.sign_up_from_date);
                mdate.duration = mdate.module_period.duration;
                return mdate;
            });
        },
    },
    methods: {
        openMotivationEditModal(module, date) {
            this.$refs[`edit-module-motivation-modal`].show(module, date);
        },

        signInTill(moduleDate) {
            let today = moment(new Date()).format('YYYY-MM-DD');

            return moment(today).isBefore(moduleDate.module_period.period.sign_up_until_date);
        },

        show(moduleId) {
            this.subscription = ords
                .use('module')
                .with('module_teachers', (teacherCallback) => {
                    teacherCallback.with('user');
                })
                .with('module_dates', (dateCallback) => {
                    dateCallback.with('module_users');
                    dateCallback.with('module_period', (modulePeriodsCallback) => {
                        modulePeriodsCallback.with('period');
                    });
                })
                .with('file', (fileCallback) => {
                    fileCallback.with('image');
                })
                .with('module_tags')
                .find(moduleId)
                .subscribe((module) => {
                    this.module = module;
                });

            this.moduleTitle = this.module.title;
            this.tags = this.module.module_tags;
            this.moduleDates = this.module.module_dates;
            this.selectedDate = 0;
            const enrolled = this.module.getUserRegisteredPerDateData(this.$authUser.id);
            for (const [index, item] of this.moduleDates.entries()) {
                for (const data of enrolled) {
                    if (data.id === item.id) {
                        this.moduleDates[index].enrolled = data.enrolled;
                    }
                }
            }
            this.modal = true;
        },

        showRegister(moduleDate) {
            if (!moduleDate.period.sign_up_from_date && !moduleDate.period.sign_up_until_date) {
                return true;
            }

            let today = moment(new Date());
            if (today === moduleDate.period.sign_up_from_date) {
                return true;
            }

            if (!moduleDate.period.sign_up_from_date && moduleDate.period.sign_up_until_date) {
                return moment(today).isBefore(moduleDate.period.sign_up_until_date, null);
            }

            if (moduleDate.period.sign_up_from_date && !moduleDate.period.sign_up_until_date) {
                return moment(today).isSameOrAfter(moduleDate.period.sign_up_from_date, null);
            }

            return moment(today).isBetween(
                moduleDate.period.sign_up_from_date,
                moduleDate.period.sign_up_until_date,
                null,
                '[]',
            );
        },

        unRegisterForModule(moduleDate) {
            this.selectedDate = 0;
            let moduleUser = moduleDate.findModuleUserByUserId(this.$authUser.id);

            if (!moduleUser) {
                // eventuele error mag niet voorkomen dit geval
                this.alert.ajaxError(error);
            }

            this.alert
                .confirm(
                    this.$t('modules.unsubscribe_module'),
                    this.$t('modules.are_you_sure_you_want_to_unsubscribe_from_this_time_block'),
                    this.$t('modules.yes_sign_out'),
                )
                .then((confirm) => {
                    if (!confirm) {
                        return;
                    }

                    this.checkDate(moduleDate);

                    if (this.error) {
                        return;
                    }

                    this.alert.saving();
                    this.axios.delete(this.routes.deleteModuleUser(moduleUser.id)).then(
                        (response) => {
                            moduleUser.remove();
                            this.alert.success();
                        },
                        (error) => {
                            this.alert.ajaxError(error);
                        },
                    );
                });
        },

        checkDate(moduleDate) {
            let today = moment(new Date()).format('YYYY-MM-DD');

            if (!moduleDate.sign_up_until_date || !moduleDate.sign_up_from_date) {
                return;
            }

            let dateBetween = moment(today).isBetween(
                moment(moduleDate.sign_up_from_date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                moment(moduleDate.sign_up_until_date, 'DD-MM-YYYY').format('YYYY-MM-DD'),
                undefined,
                '[]',
            );

            this.error = !dateBetween;
        },

        onHide() {
            this.subscription.unsubscribe();
        },

        formatDate(inputDate) {
            const dateParts = inputDate.split(' ')[0].split('-');
            const year = dateParts[0];
            const month = dateParts[1];
            const day = dateParts[2];
            return `${day}-${month}-${year}`;
        },

        updateSignedUser(moduleUser) {
            this.$emit('update-signed-user', moduleUser);
        },
    },

    watch: {
        module: function (value) {
            this.module = value;
        },
    },
};
</script>

<style scoped lang="scss">
.module-details {
    .header {
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        img {
            object-fit: cover;
            object-position: center;
            height: 150px;
            width: 100%;
        }
    }

    .tag {
        font-weight: $font-weight-bold;
        margin-bottom: map-get($grid-gutter-spacing, 'fifteen');

        i {
            margin-right: map-get($grid-gutter-spacing, 'eight');
        }
    }

    .description {
        line-height: 1.3;
    }

    .dates {
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');

        .apprentice-simple-card {
            padding: 0;
        }

        .apprentice-table-header {
            display: none;
        }
    }
}
</style>
